<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import Error from '@/components/Error.vue';

const { t } = useI18n();
</script>

<template>
  <error
    :icon="'mdi-alert-circle'"
    :title="t('warehouseError.title')"
    :message="t('warehouseError.message')" />
</template>
